const {
    _getFinalisedEpochReport,
    _authenticateReport
} = require('../logic/balanceReporting');

class BalanceReportingSubPackage {

    constructor(signer) {
        this.etherSigner = signer;
    }

    getFinalisedEpochReport(beaconNodeUrl, blsPublicKey) {
        return _getFinalisedEpochReport(this.etherSigner, beaconNodeUrl, blsPublicKey);
    }

    authenticateReport(beaconNodeUrl, finalisedBeaconChainReport) {
        return _authenticateReport(this.etherSigner, beaconNodeUrl, finalisedBeaconChainReport);
    }
}

module.exports = {
    BalanceReportingSubPackage
};
